import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular-ivy";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '../src/app/core/extensions';
import { browserTracingIntegration } from '@sentry/angular-ivy';

if (!location.origin.includes('localhost')) {
  // Base Sentry configuration
  const sentryConfig = {
    dsn: environment.dsn,
    ignoreErrors: ['ResizeObserver loop limit exceeded', 'ZoneImpl.run', 'captureException', '<unknown>'],
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: [environment.appUrl, environment.apiUrl],
    release: environment.version.replace('v', 'ver-'),
    sendClientReports: false,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0
  };

  Sentry.init(sentryConfig);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
